import CryptoJS from 'crypto-js';

// -------------------- DEV/UAT
const skey = '0b815b4db493d9e26500ef006e1e246f2fd0fc11';
// -------------------- LIVE
// const skey = '0b815b4db493d9e26500ef006e1e246f2fd0fc11';

const encryptAES = text => {
  return CryptoJS.AES.encrypt(text, skey).toString();
};

const decryptAES = async encryptedBase64 => {
  const decrypted = await CryptoJS.AES.decrypt(encryptedBase64, skey);
  return decrypted.toString(CryptoJS.enc.Utf8);
};

export { decryptAES, encryptAES };

